import { useMutation } from '@tanstack/react-query'
import { authApi } from '@/features/auth/api/auth.api'

interface RequestPasswordResetVariables {
  email: string
}

export function useRequestPasswordReset() {
  const requestPasswordReset = useMutation<
    void,
    unknown,
    RequestPasswordResetVariables
  >({
    mutationFn: ({ email }) => authApi.requestPasswordReset(email),
  })

  return { requestPasswordReset }
}
